import { Navigate, Outlet } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const RoleProtectedRoute = ({ allowedRoles }) => {
  const isAuth = secureLocalStorage.getItem("isAuth");
  const role = secureLocalStorage.getItem("role");

  if (!isAuth) {
    return <Navigate to="/admin/login" />;
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/admin/dashboard" />;
  }

  return <Outlet />;
};

export default RoleProtectedRoute;
